module.exports = __webpack_public_path__ + "static/media/CircularPro-Bold.da9f6592.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/CircularPro-Bold.woff
// module id = 110
// module chunks = 0